module.exports = __webpack_public_path__ + "img/11_81.6ab049ab.png";